export const PAGE_SIZE = 16;
export const formContent2 = 'parts: {0} machine: 0';
export const pagePath = '/searchDisplay';
export const formName = 'search results';
export const SPECIALS = 'specials';
export const SPECIALS_FACET_ID = 'specials_facet';
